/**
 * This function serves as a workaround to replicate the behavior of Promise.withResolvers,
 * as we are currently using react-scripts: 5.0.1, which lacks support for TypeScript 5.x features.
 *
 * Creates a promise along with its associated resolve and reject functions.
 *
 * @returns An object containing:
 * - `promise`: The created promise that can be resolved or rejected.
 * - `resolve`: A function to resolve the promise with a value or a Promise-like object.
 * - `reject`: A function to reject the promise with an optional reason.
 */
export function promiseWithResolvers<T>(): {
  promise: Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: any) => void;
} {
  let resolve!: (value: T | PromiseLike<T>) => void;
  let reject!: (reason?: any) => void;

  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });

  return { promise, resolve, reject };
}
